const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'icons',
  tiles: {
    ability_back1: 0,
    ability_back2: 1,
    ability_demo: 2,
    ability_gun1: 3,
    ability_gun2: 4,
    ability_heal: 5,
    ability_heal_all: 6,
    ability_heal_and_shield: 7,
    ability_heal_other_shield_self: 8,
    'ability_heal-bad': 9,
    ability_poison1: 10,
    ability_poison2: 11,
    ability_ranged_all1: 12,
    ability_ranged_all2: 13,
    ability_shield_all: 14,
    ability_shield1: 15,
    ability_shield2: 16,
    aggro: 17,
    attack_all: 18,
    attack_back: 19,
    attack_front: 20,
    attack_front_enemy: 21,
    die1: 22,
    die2: 23,
    die3: 24,
    die4: 25,
    die5: 26,
    die6: 27,
    diewild: 28,
    heal: 29,
    heal_all: 30,
    healthbar_left: 31,
    healthbar_right: 32,
    hero_bg: 33,
    hero_bg_chat: 34,
    hero_bg_empty: 35,
    poison: 36,
    rank1: 37,
    rank1md: 38,
    rank2: 39,
    rank2md: 40,
    sanity24: 41,
    shield: 42,
    shield_all: 43,
    shield_on_black: 44,
    skull: 45,
    spacer: 46,
    star: 47,
    xpbar: 48
  },
  uidata: {
    rects: [
      vec4(8/1024,8/128,32/1024,32/128),
      vec4(48/1024,8/128,72/1024,32/128),
      vec4(88/1024,8/128,112/1024,32/128),
      vec4(128/1024,8/128,152/1024,32/128),
      vec4(168/1024,8/128,192/1024,32/128),
      vec4(208/1024,8/128,232/1024,32/128),
      vec4(248/1024,8/128,272/1024,32/128),
      vec4(288/1024,8/128,312/1024,32/128),
      vec4(328/1024,8/128,352/1024,32/128),
      vec4(368/1024,8/128,392/1024,32/128),
      vec4(408/1024,8/128,432/1024,32/128),
      vec4(448/1024,8/128,472/1024,32/128),
      vec4(488/1024,8/128,512/1024,32/128),
      vec4(528/1024,8/128,552/1024,32/128),
      vec4(568/1024,8/128,592/1024,32/128),
      vec4(608/1024,8/128,632/1024,32/128),
      vec4(648/1024,8/128,672/1024,32/128),
      vec4(688/1024,8/128,697/1024,17/128),
      vec4(713/1024,8/128,724/1024,17/128),
      vec4(740/1024,8/128,749/1024,17/128),
      vec4(765/1024,8/128,774/1024,17/128),
      vec4(790/1024,8/128,799/1024,17/128),
      vec4(815/1024,8/128,825/1024,18/128),
      vec4(841/1024,8/128,851/1024,18/128),
      vec4(867/1024,8/128,877/1024,18/128),
      vec4(893/1024,8/128,903/1024,18/128),
      vec4(919/1024,8/128,929/1024,18/128),
      vec4(945/1024,8/128,955/1024,18/128),
      vec4(971/1024,8/128,981/1024,18/128),
      vec4(997/1024,8/128,1006/1024,17/128),
      vec4(8/1024,48/128,19/1024,57/128),
      vec4(35/1024,48/128,40/1024,53/128),
      vec4(56/1024,48/128,61/1024,53/128),
      vec4(77/1024,48/128,220/1024,93/128),
      vec4(236/1024,48/128,284/1024,92/128),
      vec4(300/1024,48/128,443/1024,93/128),
      vec4(459/1024,48/128,468/1024,57/128),
      vec4(484/1024,48/128,493/1024,59/128),
      vec4(509/1024,48/128,518/1024,57/128),
      vec4(534/1024,48/128,543/1024,59/128),
      vec4(559/1024,48/128,568/1024,57/128),
      vec4(584/1024,48/128,608/1024,72/128),
      vec4(624/1024,48/128,633/1024,57/128),
      vec4(649/1024,48/128,660/1024,57/128),
      vec4(676/1024,48/128,685/1024,57/128),
      vec4(701/1024,48/128,710/1024,57/128),
      vec4(726/1024,48/128,735/1024,57/128),
      vec4(751/1024,48/128,760/1024,56/128),
      vec4(776/1024,48/128,809/1024,77/128)
    ],
    aspect: [
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
      1.2222222222222223,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
      1.2222222222222223,                  1,                  1,
      3.1777777777777776, 1.0909090909090908, 3.1777777777777776,
                       1, 0.8181818181818182,                  1,
      0.8181818181818182,                  1,                  1,
                       1, 1.2222222222222223,                  1,
                       1,                  1,              1.125,
      1.1379310344827587
    ]
  },
  FRAME_ABILITY_BACK1: 0,
  FRAME_ABILITY_BACK2: 1,
  FRAME_ABILITY_DEMO: 2,
  FRAME_ABILITY_GUN1: 3,
  FRAME_ABILITY_GUN2: 4,
  FRAME_ABILITY_HEAL: 5,
  FRAME_ABILITY_HEAL_ALL: 6,
  FRAME_ABILITY_HEAL_AND_SHIELD: 7,
  FRAME_ABILITY_HEAL_OTHER_SHIELD_SELF: 8,
  'FRAME_ABILITY_HEAL-BAD': 9,
  FRAME_ABILITY_POISON1: 10,
  FRAME_ABILITY_POISON2: 11,
  FRAME_ABILITY_RANGED_ALL1: 12,
  FRAME_ABILITY_RANGED_ALL2: 13,
  FRAME_ABILITY_SHIELD_ALL: 14,
  FRAME_ABILITY_SHIELD1: 15,
  FRAME_ABILITY_SHIELD2: 16,
  FRAME_AGGRO: 17,
  FRAME_ATTACK_ALL: 18,
  FRAME_ATTACK_BACK: 19,
  FRAME_ATTACK_FRONT: 20,
  FRAME_ATTACK_FRONT_ENEMY: 21,
  FRAME_DIE1: 22,
  FRAME_DIE2: 23,
  FRAME_DIE3: 24,
  FRAME_DIE4: 25,
  FRAME_DIE5: 26,
  FRAME_DIE6: 27,
  FRAME_DIEWILD: 28,
  FRAME_HEAL: 29,
  FRAME_HEAL_ALL: 30,
  FRAME_HEALTHBAR_LEFT: 31,
  FRAME_HEALTHBAR_RIGHT: 32,
  FRAME_HERO_BG: 33,
  FRAME_HERO_BG_CHAT: 34,
  FRAME_HERO_BG_EMPTY: 35,
  FRAME_POISON: 36,
  FRAME_RANK1: 37,
  FRAME_RANK1MD: 38,
  FRAME_RANK2: 39,
  FRAME_RANK2MD: 40,
  FRAME_SANITY24: 41,
  FRAME_SHIELD: 42,
  FRAME_SHIELD_ALL: 43,
  FRAME_SHIELD_ON_BLACK: 44,
  FRAME_SKULL: 45,
  FRAME_SPACER: 46,
  FRAME_STAR: 47,
  FRAME_XPBAR: 48
};
spritesheetRegister(module.exports);
